import React from 'react';
import { Skeleton, Row, Col, Card } from 'antd';
import './styles.scss';

export const ActivityCheckoutSkeleton: React.FC = () => {
    return (
        <div className="activity-checkout-skeleton">
            <div className="activity-checkout-container">
                <div className="checkout-header-skeleton">
                    <Skeleton.Button active style={{ width: 150, marginBottom: '16px' }} />
                    <Skeleton active title={{ width: '30%' }} paragraph={{ rows: 1, width: '40%' }} />
                </div>

                <Row gutter={24}>
                    <Col xs={24} lg={14} xl={16}>
                        <div className="booking-steps-skeleton">
                            {/* Step 1 Skeleton */}
                            <Card className="step-card-skeleton active">
                                <div className="step-header-skeleton">
                                    <Skeleton.Avatar active shape="circle" size="small" />
                                    <Skeleton active title={{ width: '20%' }} paragraph={false} />
                                </div>
                                <div className="step-content-skeleton">
                                    <Skeleton active paragraph={{ rows: 1, width: '70%' }} />
                                    <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
                                        <Col span={4}><Skeleton.Input active block /></Col>
                                        <Col span={10}><Skeleton.Input active block /></Col>
                                        <Col span={10}><Skeleton.Input active block /></Col>
                                        <Col span={24}><Skeleton.Input active block /></Col>
                                        <Col span={8}><Skeleton.Input active block /></Col>
                                        <Col span={16}><Skeleton.Input active block /></Col>
                                        <Col span={24}><Skeleton.Input active block /></Col>
                                    </Row>
                                    <div className='skelton_step_button' style={{ marginTop: '24px' }}>
                                        <Skeleton.Button active size="large" style={{ width: 100 }} />
                                        <Skeleton.Button active size="large" style={{ width: 100 }} />
                                    </div>
                                </div>
                            </Card>

                            {/* Step 2 Skeleton Preview */}
                            <Card className="step-card-skeleton disabled">
                                <div className="step-header-skeleton">
                                    <Skeleton.Avatar active shape="circle" size="small" />
                                    <Skeleton active title={{ width: '20%' }} paragraph={false} />
                                </div>
                            </Card>

                            {/* Step 3 Skeleton Preview */}
                            <Card className="step-card-skeleton disabled">
                                <div className="step-header-skeleton">
                                    <Skeleton.Avatar active shape="circle" size="small" />
                                    <Skeleton active title={{ width: '20%' }} paragraph={false} />
                                </div>
                            </Card>
                        </div>
                    </Col>

                    <Col xs={24} lg={10} xl={8}>
                        <Card className="booking-summary-skeleton">
                            <div className="summary-image-skeleton" />
                            <div className="summary-content-skeleton">
                                <Skeleton active title={{ width: '90%' }} paragraph={{ rows: 2, width: ['60%', '40%'] }} />
                                <div className="summary-details-skeleton">
                                    <Skeleton active paragraph={{ rows: 3 }} />
                                </div>
                                <div className="summary-price-skeleton">
                                    <Skeleton active title={{ width: '40%' }} paragraph={false} />
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
